import { motion } from "motion/react";

export function DiamondLogo({ size = 120 }: { size?: number }) {
  const half = size / 2;
  const inset = size * 0.18;

  return (
    <motion.div
      className="diamond-logo"
      style={{ width: size, height: size }}
      animate={{ rotate: [0, 360] }}
      transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
    >
      <svg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="diamond-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#50fa7b" />
            <stop offset="50%" stopColor="#bd93f9" />
            <stop offset="100%" stopColor="#8be9fd" />
          </linearGradient>
          <filter id="diamond-glow">
            <feGaussianBlur stdDeviation="6" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <linearGradient id="diamond-inner-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#eafff3" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#bd93f9" stopOpacity="0.6" />
          </linearGradient>
        </defs>

        {/* Outer diamond */}
        <motion.polygon
          points={`${half},2 ${size - 2},${half} ${half},${size - 2} 2,${half}`}
          stroke="url(#diamond-grad)"
          strokeWidth="1.5"
          fill="none"
          filter="url(#diamond-glow)"
          animate={{ opacity: [0.7, 1, 0.7] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Inner diamond */}
        <motion.polygon
          points={`${half},${inset} ${size - inset},${half} ${half},${size - inset} ${inset},${half}`}
          stroke="url(#diamond-inner-grad)"
          strokeWidth="1"
          fill="rgba(134,255,187,0.04)"
          animate={{ opacity: [0.5, 0.85, 0.5] }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
        />

        {/* Center dot */}
        <motion.circle
          cx={half}
          cy={half}
          r="3"
          fill="#50fa7b"
          animate={{ r: [2.5, 4, 2.5], opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />
      </svg>

      {/* Glow backdrop */}
      <div className="diamond-logo__glow" />
    </motion.div>
  );
}
